import type { RunSummary } from '../run';

/** Durée (s) en dessous de laquelle une victoire rapporte un bonus de temps. */
const PAR_TIME_S = 600;

/** Score d'une run : kills, salles, niveau, bonus de victoire et de rapidité, Kamas gagnés et défis relevés. */
export function scoreOf(s: Pick<RunSummary, 'kills' | 'roomsCleared' | 'level' | 'outcome' | 'durationMs' | 'stats'>): number {
  const victory = s.outcome === 'victory';
  return s.kills * 10 + s.roomsCleared * 150 + s.level * 40
    + (victory ? 1000 : 0)
    + (victory ? 2 * Math.max(0, PAR_TIME_S - Math.round(s.durationMs / 1000)) : 0)
    + Math.round(s.stats.kamasEarned / 2)
    + s.stats.defisCleared * 100;
}
